import { createContext } from "react";
import type { To } from "react-router";
import type { ViewTransitionDirection } from "./view-transition";

export type Transition = {
  action: "PUSH" | "REPLACE";
  path: To;
  state?: unknown;
  viewTransition?: ViewTransitionDirection;
};

export interface NavigationGuardContextValue {
  registerGuard: (isActive: () => boolean) => () => void;
  attemptNavigate: (
    action: "PUSH" | "REPLACE",
    path: To,
    state?: unknown,
    viewTransition?: ViewTransitionDirection
  ) => boolean;
  pendingTransition: Transition | null;
  confirmPendingTransition: () => void;
  cancelPendingTransition: () => void;
}

export const NavigationGuardContext =
  createContext<NavigationGuardContextValue | null>(null);
